<template>
  <div class="1">
    <!-- <div class="2" style="font-size: 13px; font-family: Verdana; float: left width: 100%" :style="{height: `${gridHeight}px`,  width: `${grWidth}px`}"> -->
    <!-- <div class="2" style="font-size: 13px; font-family: Verdana; float: left width: 100%" :style="{height: `${gridHeight}px`, width: `${grWidth}px`}"> -->
    <div class="2" style="font-size: 13px; font-family: Verdana; float: left; width: 100%" :style="{height: `100%`, width: `100%`, padding: '0 2px 0 0'}">
      <div v-if="tab.resultMulti[selectIndx] && tab.resultMulti[selectIndx].err != 0" class="errorGrid">Error: {{tab.resultMulti[selectIndx].err}}, {{tab.resultMulti[selectIndx].msg}}</div> 
      <JqxGrid
      v-if="tab.resultMulti[selectIndx] && !tab.resultMulti[selectIndx].err && tab.resultMulti[selectIndx].fields &&  tab.resultMulti[selectIndx].fields.length > 0"
        class="gridStyle"    
        ref="myGrid"
        :width="width" 
        :height="bHeight"
        :showrowlines="false"
        :altrows="true"
        :rendergridrows="rendergridrows"
        :source="dataAdapter" 
        :columns="columns"
        :columnsresize="true" 
        :virtualmode="true" 
        :enabletooltips="true"
        :editable="true" 
        :selectionmode="'multiplecellsadvanced'"
        @contextmenu.native="showContext($event),showModal()"
        :theme="theme"
        @bindingcomplete="onBindingComplete"
        >
      </JqxGrid>
      <!-- @contextmenu.native="showContext($event)"
      @click.native="closeContext($event)" -->
      <modal name="example" :width="exportwidth" height="auto" :scrollable=true>
        <div class="modal-export">
          <div v-for="el,i in columns" :key="i+el.text">
            <input type="checkbox" v-if="i != 0" :id="el.text" :value="i" v-model="checkedColumns" />
            <label :for="el.text" v-if="i != 0"><span>Export column {{ el.text }}</span></label>
          </div>
          <button @click="exportColumn()">Export to excel</button>
        </div> 
      </modal>
    </div>
  </div>
</template>
<script>

import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import { commonMixin } from '../../common.js';

  export default {
    myVar: 100,  
    mixins: [commonMixin],
    components: {
      JqxGrid
    },
    props: {
      dark:{
        type: Boolean
      },
      query: {
        type: Number,
        required: true
      },
      tab: {
        type: Object,
        required: true
      },
      state: {
        type: Object,
        // required: true
      },
      bHeight: {
        required: true
      },
      width: {
        // type: Number,
        required: true,
      },
      selectIndx: {
        type: Number,
        require: true
      }
    },
    beforeCreate: function () {
      /*
      this.source = {
        url: `http://127.0.0.1:8008/api/data/result${window.hostname.idconnect}_${window.hostname.query}`,
        // url: `${window.hostname.baseUrl}/api/data/result${window.hostname.idconnect}_${window.hostname.query}`,
        // url: `/api/data/result${window.hostname.idconnect}_${window.hostname.query}`,
        datafields: [            
        ],
        columns: [
        ],
        datatype: 'json',
        root: 'value',
        cache: false,
        totalrecords: 0,
        ticks: 0,
        beforeprocessing: function(data){
          // console.log('bp',data);
          data.value.forEach(i => {
            for(var key in i){
              if (i[key] === null) {
                i[key] = 'null';              
              }
              this.datafields.push({name:key,type:'string'});
            }
          })
          window.hostname.fields = []
          let gridWidth = window.hostname.width
          let columnsWidth = []
          this.totalrecords = data['odata.count']
          for (let index = 0; index < this.columns.length; index++) {
            columnsWidth.push([])
            let valHead
            if (this.columns[index].text == null) {
              valHead = ("Null".toString().length * 9) + 10
            } else {          
              valHead = (this.columns[index].text.toString().length * 9) + 10
            }
            // console.log('bfp', gridWidth);
            if (valHead > gridWidth/2) {
              valHead = gridWidth/2
            }
            columnsWidth[index].push(valHead)
          }
          for (let index = 0; index < this.columns.length-1; index++) {  
            data.value.forEach((el,ind) => {
              // console.log('bfp',index);
              // console.log('bfp',el[index]);
              if (index !== this.columns.length) {
                let key = Object.keys(el)[index]
                let val
                if (el[key] == null) {
                  val = ("Null".toString().length * 9) + 10
                } else {              
                  val = (el[key].toString().length * 9) + 10
                }
                // console.log('bfp', gridWidth);
                if (val > gridWidth/2) {
                  val = gridWidth/2
                }
                columnsWidth[index+1].push(val)
              }
            })         
          }

          let columnsWidth2 = columnsWidth.map( i => Math.max(...i) )
            this.columns.forEach((el,ind) => {
              if (ind !== 0) {
                el.width = columnsWidth2[ind]
              }
            })
          this.ticks = 5
          window.hostname.loading = false  
        }
      }
      */
    },
    created() {
      this.columns.push(
        {
          text: '#', sortable: false, filterable: false, editable: false, 
          groupable: false, draggable: false, resizable: true, pinned: true,
          datafield: '#', columntype: 'number', width: 50,align:'center',
          cellsrenderer: (row, column, value) => {
            return '<div style="display: flex; align-items: center; width: 100%; height: 100%; background: transparent; justify-content: center;">' + (value + 1) + '</div>';
          }
        },
      )
      
      // console.log('grid window hostName',window.hostname.query);
      if (this.tab.resultMulti[this.query].fields) {
        this.tab.resultMulti[this.query].fields.forEach((element,ind) => {
          this.columns.push(
            { 'text': element.charAt(0).toUpperCase() + element.slice(1), datafield: ind, width: 100 }
          )
        });        
      }
      // console.log('created columns',this.columns);
      this.initJqxGrid(this.columns)

      this.dataAdapter = new jqx.dataAdapter(this.source)
      this.tics = this.source.ticks

    },
    computed: {
      gridHeight: function() {
        return this.bHeight - 28
      },
      grWidth: function() {
        return this.width
      },
      exportHeight() {
        // console.log('exportHeight',this.columns.length * 36 );
        return this.columns.length * 36 
      },
      exportwidth() {
        let width = null
        this.columns.forEach((el,i) => {
          if (i != 0) {
            let str = el.text.length * 9
            // console.log('columns', str); 
            if (!width) {
              width = str
            } else if ( width < str ) {
              width = str
            }             
          }
        })
        // console.log('width', width); 
        return width + 153
      }

    },
    mounted() {
    //   console.log('grid',this.tab );
    //   console.log('grid',this.selectIndx );
      this.interval = setInterval(() => {
        // console.log('dataAdapter',this.dataAdapter );
        let a
        if (this.dataAdapter) {
          a = this.dataAdapter._source 
          
        }
        // console.log('dataAdapter',a );
        if (a !== undefined) {
          if (a.ticks > 0) {
            a.ticks--
            // console.log('int1',a.ticks);
          }
          if (this.$refs.myGrid) {
            this.$refs.myGrid.refresh();
          }
          if (a.ticks == 0) {
            this.change()
            // console.log('int2');
            // if (this.tab[0].rowscount === a.totalrecords) {
                clearInterval(this.interval)
              // }
          }          
        } else {
          clearInterval(this.interval)
        }
      }, 50);
      this.columns.forEach((element,i) => {
        if (i != 0) {
          this.checkedColumns.push(i)          
        }
      });
      if (this.dark) {
        console.log('m');        
        this.theme = 'dark'
        this.$refs.myGrid.setOptions({ theme: this.theme });
      } else {
        console.log('m2');
        this.theme = ''
        this.$refs.myGrid.setOptions({ theme: this.theme });
      }
    },

    beforeUnmount() {
      clearInterval(this.intrval)
    },
    data: function () {
      return {
        theme: '',
        dataAdapter: null,
        // columns: this.source.columns,
        columns: [],
        interval: null,
        chHeight: null,
        top: 0,
        left: 0,
        isDisplay: false,
        tics: 0,
        checkedColumns: [],
        isGridInitialized: false
      }
    },
    watch: {
      bHeight: function() {
        this.$refs.myGrid.refresh();
      },
      width: function() {
        if (this.$refs.myGrid) {
          this.$refs.myGrid.refresh();
        }
      },
      dark() {
        this.toggleTheme()
      }
    },
    methods: {
      onBindingComplete() {
        this.isGridInitialized = true
      },
      async handleResizeComplete() {
        if (!this.isGridInitialized || !this.$refs.myGrid) return

        await this.$nextTick()
        
        const grid = this.$refs.myGrid
        const containerHeight = this.$el.clientHeight
        // 1. Обновляем высоту грида
        // grid.height(containerHeight)
        const dataSource = grid.source._source
        // console.log('handleResizeComplete', Math.ceil(containerHeight - 36)/33);
        let newRec = Math.ceil((containerHeight - 36)/33 + 2)
        // console.log('handleResizeComplete', dataSource.recordendindex, newRec);
        dataSource.recordendindex = newRec
        // 2. Сбрасываем кэш данных и принудительно обновляем
        this.forceGridRefresh(grid)
      },
      forceGridRefresh(grid) {
        // Метод 1: Просто обновляем данные
        grid.updatebounddata()
        
        // Метод 2: Сбрасываем на первую страницу (если нужно)
        // grid.gotopage(1)
        
        // Метод 3: Полное обновление (более агрессивное)
        // grid.source = this.dataAdapter
        // grid.refresh()
      },
      toggleTheme() {
        console.log('toggleTheme', this.dark);        
        this.theme = this.dark ? 'dark' : '';
        console.log('toggleTheme', this.theme);        
        // this.loadTheme(this.theme);
        this.$refs.myGrid.setOptions({ theme: this.theme });
        this.$refs.myGrid.refresh();
      },    
      async loadFields(fields) {
        await fields
      },
      closeContext() {
        if (this.isDisplay) {
          this.isDisplay = false
        } 
      },
      showContext(e) {
        e.preventDefault();
        console.log('showContext');
        this.top = e.clientY
        this.left = e.clientX
        if (this.isDisplay) {
          this.isDisplay = false
        } else {
          this.isDisplay = true
        }
      },
      exportColumn() {
        this.isDisplay = false
        let arrExport = []
        let records = null
        console.log('this.query:',this.query);
        let response = axios.get(
          this.baseUrl + `/api/data/result${this.tab.idconnect}_${this.query}?filterscount=0&groupscount=0&pagenum=1&pagesize=10&recordstartindex=0&recordendindex=10000&_=1709631594228`,
				).then((resp) => {
            const regExp = /"/gmi
            let text = ''
            this.columns.forEach((el,ind) => {
              if (this.checkedColumns.find((it,i)=> it == ind)) {
                if (ind == 0) {                 
                  text = `"${el['text']}";` 
                } else {
                  text += `"${el['text']}";`
                }
              }
            })
            let hdr = '"#";' + text
            hdr += '\n'
            arrExport.push(hdr)
            records = String(resp.data['odata.count']).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ");
            
            resp.data.value.forEach((el,i) => {
              let str = ''
              let strArr = []
              strArr.push(i+1)             
              for (const key in el) {
                if (this.checkedColumns.find((it,i)=> it-1 == key)) {
                  if (Object.hasOwnProperty.call(el, key)) {
                    let element = el[key];
                    if (typeof(element) == 'string') {
                      element = element.replace(regExp, '""')
                      element= '"' + element + '"'
                    }     
                    strArr.push(element)                    
                  }
                }
              } 
              str = strArr.join(';')
              str += '\n'
              arrExport.push(str)               
            })
            if (resp.data['odata.count'] > 10000) {
              this.ShowAlert(`Attention! 10 000 records will be exported from ${records}`);
            }
            this.downloadAsFile(arrExport.join(''),'gridColumn.csv','text/csv;charset=utf-8;')
						this.loading = false
						return resp
					})
      },
      exportToExcel() {    
        console.log('exportToExcel')    
        let arrExport = []
        let records = null
        let response = axios.get(
          this.baseUrl + `/api/data/result${this.tab.idconnect}_${this.query}?filterscount=0&groupscount=0&pagenum=1&pagesize=10&recordstartindex=0&recordendindex=10000&_=1709631594228`,
				).then((resp) => {
          const regExp = /"/gmi
            let hdr = ''
            this.columns.forEach((el,i) => {
              let txt 
              if (i < this.columns.length - 1) {
                // console.log(i);
                txt = el.text.replace(regExp, '""')
                txt = '"' + txt + '"'
                hdr += txt  + ';'
                // console.log('Excel',hdr)
              } else if (i == this.columns.length - 1) {
                txt = el.text.replace(regExp, '""')
                txt = '"' + txt + '"'
                // console.log(i);
                hdr += txt
              }
            })           
            hdr += '\n'
            // console.log('hdr',hdr)
            arrExport.push(hdr)
            // console.log('resp.data', resp.data['odata.count']);
            records = String(resp.data['odata.count']).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ");
            resp.data.value.forEach((el,i) => {
              let str = ''
              let strArr = []
              strArr.push(i+1)
              for (const key in el) {
                if (Object.hasOwnProperty.call(el, key)) {
                  let element = el[key]; 
                  // console.log('typeof',typeof(element));                    
                  if (typeof(element) == 'string') {
                    // element = element + ''
                    element = element.replace(regExp, '""')
                    // element = element.replace('r', '')
                    // element = element.replace(regExp2, " ")
                    element= '"' + element + '"'
                  }                 
                  // const regExp2 = /\r/gmi
                  strArr.push(element)
                }
              } 
              str = strArr.join(';')
              str += '\n'
              // console.log('str',str)
              arrExport.push(str)               
            })
           
            if (resp.data['odata.count'] > 10000) {
              this.ShowAlert(`Attention! 10 000 records will be exported from ${records}`);
            }            
            // console.log('arrExport0',arrExport);
            // console.log('arrExport',arrExport.join(''));
            this.downloadAsFile(arrExport.join(''),'grid.csv','text/csv;charset=utf-8;')
            // let blob = new Blob([arrExport.join('\n\r')], { type: 'text/plain' });
            // let file = new File([blob], "grid.txt", {type: "text/plain"});

            // this.$refs.contextMenu.href = URL.createObjectURL(blob);
            // this.$refs.contextMenu.download = "grid.txt";
						this.loading = false
						return resp
					}
        )
        this.isDisplay = false
      },
      rendergridrows: function (params) {
        return params.data;
      },
      change() {
        if (this.$refs.myGrid) {
          let position = this.$refs.myGrid.scrollposition();
          this.dataAdapter._source.totalrecords = this.tab.resultMulti[0].rowscount
          this.$refs.myGrid.scrolloffset(0,0);
          this.$refs.myGrid.scrolloffset(position.top, position.left);
        }
      },
      downloadAsFile(data, name, type) {
        const url = window.URL.createObjectURL(new Blob([
          new Uint8Array([0xEF, 0xBB, 0xBF]),
          data
        ],{type: type}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      initJqxGrid(col) {
        // console.log('initJqxGrid idconnect',this.tab.idconnect);
        // console.log('initJqxGrid query',this.query);
        window.hostname.query = 0
        this.source = {        
          url: `${this.baseUrl}/api/data/result${this.tab.idconnect}_${this.query}`,
          // url: `${window.hostname.baseUrl}/api/data/result${window.hostname.idconnect}_${window.hostname.query}`,
          // url: `/api/data/result${this.tab.idconnect}_${this.query}`,
          datafields: [
            ],
          columnsWidth2:[],
          columns: [
            ],
          datatype: 'json',
          root: 'value',
          cache: false,
          totalrecords: 0,
          ticks: 0,
          beforeprocessing: function(data){
            console.log('grid bp',col);
            // if (data.odata) {            
            this.totalrecords = data['odata.count']
            // }
            this.datafields = []
            this.datafields.push({name:'#',type:'string'});
            data.value.forEach(el => {
              // if (el === null) {
                for (var key in el) {
                  if (el[key] === null) {
                    el[key] = 'null';
                  }
                  this.datafields.push({ name: key, type: 'string' });
                }
                // data.value[0].forEach(i => {
                // })
              // }
            })
            /*
            data.value.forEach(i => {            
              for(var key in i){
                if (i[key] === null) {
                  i[key] = 'null';              
                }
                this.datafields.push({name:key,type:'string'});
              }
            })
            */ 
           window.hostname.columnsWidth2 = []
            // let gridWidth = document.querySelectorAll('.tab-container').clientWidth
            // console.log('bp',window.hostname);
            let gridWidth = window.hostname.width
            let columnsWidth = []
            for (let index = 0; index < col.length; index++) {
              columnsWidth.push([])
              let valHead
              if (col[index].text == null) {
                valHead = ("Null".toString().length * 9) + 10
              } else {          
                valHead = (col[index].text.toString().length * 9) + 10
              }
              // console.log('bfp', gridWidth);
              if (valHead > gridWidth/2) {
                valHead = gridWidth/2
              }
              columnsWidth[index].push(valHead)
            }
            for (let index = 0; index < col.length-1; index++) {  
              data.value.forEach((el,ind) => {
                // console.log('bfp',index);
                // console.log('bfp',el[index]);
                if (index !== this.columns.length) {
                  let key = Object.keys(el)[index]
                  let val
                  if (el[key] == null) {
                    val = ("Null".toString().length * 9) + 10
                  } else {              
                    val = (el[key].toString().length * 9) + 10
                  }
                  // console.log('bfp', gridWidth);
                  if (val > gridWidth/2) {
                    val = gridWidth/2
                  }
                  columnsWidth[index+1].push(val)
                }
              })         
            }
            
            let columnsWidth2 = columnsWidth.map( i => Math.max(...i) )
            this.columns.forEach((el,ind) => {
              if (ind !== 0) {
                el.width = columnsWidth2[ind]
              }
            })
            this.ticks = 5
            // console.log('sMЬP',this.columns);
            window.hostname.loading = false
          }
        }
      },
      showModal() {
        this.$modal.show('example',)
      }
    }
}

    
</script>
<style src='../../assets/styles/jqwidgets/jqx.base.css'></style>
<style src='../../assets/styles/jqwidgets/jqx.dark.css'></style>